import { Box } from "@primer/react";
import React, { useEffect, useState } from "react";
import { crmHocSinhApi } from "../../../api/crmHocSinhApi";
import Modal from "../../../components/ui/modal";
import { useWindowSize } from "../../../hooks/useWindowSize";
import LichSuXuongPhongYTePage from "./LichSuXuongPhongYTe";
import SucKhoeHocSinhPage from "./SucKhoeHocSinhPage";

interface SucKhoeModalProps {
  hocSinhId: number;
  onClose: () => void;
}

const SucKhoeModal: React.FC<SucKhoeModalProps> = ({ hocSinhId, onClose }) => {
  const { height } = useWindowSize();
  const [hocSinh, setHocSinh] = useState<any>({ id: 0, ho_ten: "" });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (hocSinhId > 0) {
      handleGetHocSinhData();
    }
  }, [hocSinhId]);

  const handleGetHocSinhData = async () => {
    setIsLoading(true);
    try {
      const res = await crmHocSinhApi.getById(hocSinhId, '2024-2025');
      if (res.is_success && res.data) {
        setHocSinh(res.data);
      }
    } catch (error) {
      console.error("Error fetching student data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title={`Thông tin sức khỏe - ${hocSinh.ho_ten || "Học sinh"}`}
      sx={{ width: "1000px" }}
    >
      <Box sx={{
        p: 2,
        overflow: "hidden",
        height: height - 200
      }}>
        <Box
          sx={{
            overflow: "auto",
            height: "100%"
          }}
        >
          {!isLoading && hocSinhId > 0 && (
            <>
              <SucKhoeHocSinhPage ts_hocsinh_id={hocSinhId} />
            </>
          )}
          {isLoading && (
            <Box sx={{ 
              display: "flex", 
              justifyContent: "center", 
              alignItems: "center", 
              height: "200px" 
            }}>
              Đang tải...
            </Box>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default SucKhoeModal;
